module.exports = __webpack_public_path__ + "img/logo.b3930504.png";